export default function PrivacyPolicy() {
  const S = ({ title, children }) => (
    <div className="mt-8">
      <h2 className="font-display text-xl text-[#194324] font-semibold">{title}</h2>
      <div className="mt-2 text-[#314337] leading-relaxed space-y-2">{children}</div>
    </div>
  );
  return (
    <section className="max-w-3xl mx-auto px-6 py-16" data-testid="privacy-policy-page">
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#B38728] font-mono">Privacy Policy</p>
      <h1 className="font-display text-4xl sm:text-5xl font-semibold text-[#194324] mt-2">Hatha Vidya Charitable Trust</h1>
      <p className="mt-4 text-sm text-[#5C7264]">Applies to the website hathavidyacharitabletrust.org and the Hatha Vidya Android app. Last updated: 20 October 2026.</p>
      <S title="Information we collect">
        <p>Only the details you choose to submit: name, mobile number, email address and, for volunteers, address, skills, interests and availability. Members who create an app login also set a password, which is stored only in encrypted (hashed) form.</p>
        <p>We do not collect location, contacts, photos, payment card details or advertising identifiers, and the app has no advertising or third-party analytics.</p>
      </S>
      <S title="How we use it">
        <p>To process membership and volunteer registrations, respond to enquiries, allow members to log in to their profile and Digital Member ID, and verify membership through the member's QR code.</p>
      </S>
      <S title="Sharing">
        <p>We do not sell or share your personal information. It is visible only to authorised Trust administrators. Scanning a member's QR code shows only the member's name, Member ID, membership type and whether the membership is active.</p>
      </S>
      <S title="Security and retention">
        <p>Data is sent over encrypted HTTPS connections and kept while your membership or enquiry is active, or as required for Trust records.</p>
      </S>
      <S title="Your choices">
        <p>You may ask us to correct or delete your information at any time using the contact details on our Contact page.</p>
      </S>
    </section>
  );
}
